module.exports = "/static-assets/_next/static/images/img-6c3b3bca25-f83fed01009f4cb8628e403eb810f5da.webp";